import React from "react";
import { ListGroup, ListGroupItem } from 'reactstrap'
import { FormattedMessage } from 'react-intl';
import { ToggleProductGroup } from './actions/ToggleProductGroup';

import { PRODUCT_GROUPS } from '../../../../config/constants';
import { SimpleSignaturesFields } from './SimpleSignaturesFields';
import { QualifiedSignaturesFields } from './QualifiedSignaturesFields';
import { CertificateFields } from './CertificateFields';
import { CertificateWithAuthFields } from './CertificateWithAuthFields';

function ListProductGroups(props) {
  const { productGroups, formikProps } = props;

  if (! Array.isArray( productGroups ) || productGroups.length === 0) {
    return (
      <ListGroup>
        <ListGroupItem>
          <FormattedMessage id="messages.no_data"/>
        </ListGroupItem>
      </ListGroup>
    );
  }

  const renderItem = (productGroup, index) => {
    let shouldRenderQualifiedSignatures = false;
    if ( props.organization ) {
      if (props.organization.certificates.with.length) {
        shouldRenderQualifiedSignatures = true;
      }
    }

    // Don't show qualified certificate section if no certificate is selected or organization has no certificate available
    if (!shouldRenderQualifiedSignatures && productGroup.name === PRODUCT_GROUPS.QUALIFIED_SIGNATURE.name) {
      if (! formikProps.values.usersWithCertificate.length > 0 ||
        ! parseFloat( formikProps.values.certificatesNumber ) > 0 ||
        ! parseFloat( formikProps.values.certificatesValue ) > 0) {
        return;
      }
    }

    return ( <div key={index}>
        <ListGroupItem
          className={`product-group-item ${productGroup.selected ? 'selected' : ''}`}>
          <span className="name">{productGroup.text}</span>
          {!productGroup.selected && <ToggleProductGroup
            index={index}
            productGroup={productGroup}
            method="add"
            toggleProductGroup={(productGroup) => props.toggleProductGroup( productGroup, props.formikProps, 'add' )}
          />}
          {productGroup.selected && <ToggleProductGroup
            index={index}
            productGroup={productGroup}
            method="remove"
            toggleProductGroup={(productGroup) => props.toggleProductGroup( productGroup, props.formikProps, 'remove' )}
          />}
        </ListGroupItem>
        {productGroup.name === PRODUCT_GROUPS.SIMPLE_SIGNATURE.name && props.isSimpleSignature &&
        <SimpleSignaturesFields
          formikProps={formikProps}
          productGroups={productGroups}
          getErrorClass={props.getErrorClass}
        />}
        {productGroup.name === PRODUCT_GROUPS.QUALIFIED_SIGNATURE.name && props.isQualifiedSignature &&
        <QualifiedSignaturesFields
          formikProps={formikProps}
          productGroups={productGroups}
          getErrorClass={props.getErrorClass}
        />}
        {productGroup.name === PRODUCT_GROUPS.CERTIFICATE.name && props.isCertificate &&
        <CertificateFields
          formikProps={formikProps}
          productGroups={productGroups}
          getErrorClass={props.getErrorClass}
          users={props.users}
          organization={props.organization}
        />}
        {productGroup.name === PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.name && props.isCertificateWithAuth &&
        <CertificateWithAuthFields
          formikProps={formikProps}
          productGroups={productGroups}
          getErrorClass={props.getErrorClass}
          users={props.users}
          organization={props.organization}
        />}
      </div>
    );
  }

  return (
    <ListGroup className="product-group-list">
      {productGroups.map( renderItem )}
    </ListGroup>
  );
}

export { ListProductGroups }
